import React from 'react';

import { Button, Spinner } from '@ergeon/core-components';
import { LockClosedIcon } from '@ergeon/icons/hero/outline';

type AuthPromptProps = {
  isLoading: boolean;
  onLogIn: () => void;
};

const SPINNER_BORDER_WIDTH = 0.1;
const SPINNER_SIZE = 48;

const AuthPrompt = ({ isLoading, onLogIn }: AuthPromptProps) => {
  if (isLoading) {
    return (
      <div aria-label="Checking your session" className="flex justify-center px-4 py-24" role="status">
        <Spinner active borderWidth={SPINNER_BORDER_WIDTH} color="blue" size={SPINNER_SIZE} />
      </div>
    );
  }

  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 px-4 py-24 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-blue-50 dark:bg-gray-800">
        <LockClosedIcon aria-hidden="true" className="size-6 text-blue-600 dark:text-blue-300" />
      </span>
      <h1 className="heading-3 text-gray-900 dark:text-white">You are not logged in</h1>
      <p className="paragraph-1 text-gray-700 dark:text-gray-300">
        The Company Wiki is for the Ergeon team. Log in with your Ergeon account to read it.
      </p>
      <Button flavor="primary" onClick={onLogIn}>Log in with Ergeon Account</Button>
    </div>
  );
};

export default AuthPrompt;
